import React from 'react';
import { Lock, Copy } from 'lucide-react';
import { Button } from './ui/button';

const tsField = (status) => `${status.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()}_at`;

export const LockedDocBanner = ({ doc, label, onDuplicate }) => {
  if (!doc) return null;
  const at = doc[tsField(doc.status)];
  const canceled = doc.status === 'Canceled';
  return (
    <div
      className={`flex items-start justify-between gap-4 flex-wrap rounded-sm border px-4 py-3 ${canceled ? 'bg-red-50 border-red-200 text-red-900' : 'bg-amber-50 border-amber-300 text-amber-900'}`}
      data-testid="locked-doc-banner"
    >
      <div className="flex items-start gap-3">
        <Lock className="w-5 h-5 mt-0.5 shrink-0" />
        <div className="text-sm leading-snug">
          <p className="font-semibold" data-testid="locked-doc-banner-title">
            This {label} is {doc.status} and locked. All fields are read-only.
          </p>
          <p className="text-xs opacity-80 mt-0.5" data-testid="locked-doc-banner-detail">
            {at ? `Locked on ${new Date(at).toLocaleString()}. ` : ''}
            {canceled && doc.cancel_reason ? `Reason: ${doc.cancel_reason}. ` : ''}
            Need changes? Duplicate it as a new Draft, or ask an Admin to use "Reopen as Draft".
          </p>
        </div>
      </div>
      <Button size="sm" variant="outline" onClick={onDuplicate} className="rounded-sm bg-white border-current" data-testid="locked-doc-duplicate-btn">
        <Copy className="w-3.5 h-3.5 mr-1" /> Duplicate as new Draft
      </Button>
    </div>
  );
};

export default LockedDocBanner;
